import { render, staticRenderFns } from "./ManufacturerDetailsLayer.vue?vue&type=template&id=65e09628&scoped=true&"
import script from "./ManufacturerDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerDetailsLayer.vue?vue&type=style&index=0&id=65e09628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e09628",
  null
  
)

export default component.exports